<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"><span class="blind">close</span></button>
      <h2 class="layerTitle">추가 입력 정보 설정</h2>
      <div>
        <div class="setAdditionalItem">
          <div class="checkbox">
            <input type="checkbox" id="default_item_isRequired" v-model="defaultItem.isRequired">
            <label for="default_item_isRequired">{{ locale.required }}</label>
          </div>
          <SetLanguageValue
            class="labelField"
            :locale="locale"
            :langValue="defaultItem.label" />
          <select class="input inlineInput select" v-model="defaultItem.type">
            <option
              v-for="itemType in itemTypes"
              :key="itemType.type"
              :value="itemType.type">
              {{ itemType.label }}
            </option>
          </select>
          <button
            type="button"
            class="btn btnAuto"
            :disabled="!validateAddItem"
            @click.stop="add">
            {{ locale.add }}
          </button>
        </div>
        <div class="additionalInfos">
          <draggable
            :list="info"
            handle=".handleMove"
            animation="300">
            <transition-group type="transition"
              tag="div">
              <div
                v-for="item in info"
                :key="item.id"
                class="additionalItem">
                <div class="itemInner">
                  <div class="checkbox">
                    <input type="checkbox" :id="`${item.id}_isRequired`" v-model="item.isRequired">
                    <label :for="`${item.id}_isRequired`">{{ locale.required }}</label>
                  </div>
                  <div class="label">
                    <SetLanguageValue
                      :locale="locale"
                      :langValue="item.label" />
                  </div>
                  <select class="input inlineInput select" v-model="item.type">
                    <option
                      v-for="itemType in itemTypes"
                      :key="itemType.type"
                      :value="itemType.type">
                      {{ itemType.label }}
                    </option>
                  </select>
                  <button type="button" class="btnDel" @click="remove(item.id)"></button>
                </div>
                <div v-if="item.type !== 'input'"
                  class="addionalOptions">
                  {{ locale.select_option }}
                  <button
                    type="button"
                    class="btn sizeS btnAuto btnWhite ml5"
                    @click.stop="addItemOption(item.id)">
                    {{ locale.add }}
                  </button>
                  <div
                    v-if="item.options.length"
                    class="itemOptions">
                    <div
                      v-for="itemOption in item.options"
                      :key="itemOption.id"
                      class="optionItem">
                      <div class="optionLabel">
                        <SetLanguageValue
                          :locale="locale"
                          :langValue="itemOption.label" />
                      </div>
                      <button type="button" class="btnDel" @click.stop="removeItemOption(item.id, itemOption.id)"></button>
                    </div>

                  </div>
                  <div v-else class="infoMessage colorRed">
                    {{ locale.select_option_nodata }}
                  </div>
                </div>
                <button type="button" class="handleMove"></button>
              </div>
            </transition-group>
          </draggable>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!validateItemOptions" @click="apply">{{ locale.apply }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import UNIQUE from '@/common/unique'
import LANG from '@/common/lang'
import SetLanguageValue from '../Util/SetLanguageValue.vue'
import { locale } from 'core-js'

export default {
  name: 'ReservationAdditionalInfo',
  props: [
    'locale',
    'lang',
    'additionalInfo'
  ],
  components: {
    draggable,
    SetLanguageValue
  },
  computed: {
    defaultLang () {
      return this.lang.default
    },
    validateAddItem () {
      const label = this.defaultItem.label[this.defaultLang].length > 0
      return label
    },
    validateItemOptions () {
      return this.info.every(item => {
        return item.type === 'input' || item.options.length > 0
      })
    }
  },
  data () {
    return {
      info: this._.cloneDeep(this.additionalInfo || []),
      defaultItem: {
        id: UNIQUE.uniqueId8(),
        label: LANG.valueObj(''),
        isRequired: true,
        type: 'input',
        options: []
      },
      itemTypes: [
        { type: 'input', label: this.locale.direct_input },
        { type: 'radio', label: this.locale.editor_module_radio },
        { type: 'checkbox', label: this.locale.editor_module_checkbox },
        { type: 'select', label: this.locale.dropdown },
      ],
      defaultItemOption: {
        id: UNIQUE.uniqueId8(),
        label: LANG.valueObj(''),
      }
    }
  },
  methods: {
    add () {
      this.info.push(this._.cloneDeep(this.defaultItem))
      this.defaultItem.id = UNIQUE.uniqueId8()
      this.defaultItem.label = LANG.valueObj('')
    },
    remove (id) {
      this.info = this.info.filter(item => item.id !== id)
    },
    addItemOption (id) {
      const item = this.info.find(item => item.id === id)
      if (!item) return

      item.options.push({
        id: UNIQUE.uniqueId8(),
        label: LANG.valueObj('')
      })
    },
    removeItemOption (id, optionId) {
      const item = this.info.find(item => item.id === id)
      if (!item) return
      item.options = item.options.filter(optionItem => optionItem.id !== optionId)
    },
    apply () {
      this.$emit('apply', this.info)
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 540px;
}
.setAdditionalItem {
  display: flex;
  align-items: center;
  .labelField {
    flex: 1;
  }
  .checkbox {
    margin-right: 8px;
  }
  .input,
  .btn {
    height: 40px;
    margin-left: 4px;
    border-radius: 4px;
  }
}
.additionalInfos {
  margin-top: 8px;
}
.additionalItem {
  position: relative;
  margin-bottom: 4px;
  padding: 12px 40px 12px 12px;
  border: 1px solid $color-lgrey2;
  border-radius: 4px;
  background-color: #fff;
  .itemInner {
    display: flex;
    align-items: center;
  }
  .checkbox {
    margin-right: 8px;
  }
  .label {
    flex: 1;
    margin-right: 4px;
  }
  .input {
    height: 40px;
    margin-left: 4px;
    border-radius: 4px;
  }
  .btnDel {
    width: 30px;
    height: 40px;
    background: url('~@/assets/img/ico_close_black.svg') 50% 0 / 12px no-repeat;
    opacity: 0.4;
  }
  .handleMove {
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 100%;
    border-left: 1px solid $color-lgrey;
    background: $color-lgrey2 url('~@/assets/img/move.png') 50% 50% / 20px no-repeat;
    box-shadow: inset 0 0 3px rgba(0,0,0,0.4);
    opacity: 0.4;
    cursor: move;
  }
}
.addionalOptions {
  margin-top: 12px;
  margin-right: 12px;
  padding: 12px;
  border-radius: 8px;
  background-color: $bg-default;
}
.itemOptions {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
  margin-top: 8px;
  .optionItem {
    display: flex;
    padding: 8px 0 8px 8px;
    border: 1px solid $color-lgrey2;
    border-radius: 4px;
    background: #fff;
  }
  .optionLabel {
    flex: 1;
  }
}
</style>